<template>
  <div class="lnx-row lnx-no-gutters result-wrapper">
    <div class="lnx-col-12">
      <AHeadline text="result.headline" type="h5" />
      <AErrorMessageBox v-if="!!message" :message="message" />
      <APriceDisplay :is-loading="isLoading" :is-valid="hasValidResult" :price="price" />
      <ASavingsDisplay :is-loading="isLoading" :is-valid="hasValidResult" :savings="savings" :savings-percentage="savingsPercentage" />
      <div class="cta">
        <LButton block @click="onContactButtonClick">{{ $t('result.button_contact') }}</LButton>
        <LButton :disabled="!hasValidResult" block variant="secondary" @click="onDetailButtonClick">
          {{ $t('result.button_details') }}
        </LButton>
        <!--        <LButton block color="tertiary" disabled @click="onPdfButtonClick">{{ $t('result.button_pdf') }}</LButton>-->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AHeadline from '@/components/atoms/content/headline/A-Headline.vue'
import APriceDisplay from '@/components/atoms/display/price/A-PriceDisplay.vue'
import ASavingsDisplay from '@/components/atoms/display/savings/A-SavingsDisplay.vue'
import AErrorMessageBox from '@/components/atoms/error-message-box/A-ErrorMessageBox.vue'
import { LButton } from '@wgg.hyve/hyve-ui-library'

type Props = {
  isLoading: boolean
  message?: string
  price: number | null
  savings: number | null
  savingsPercentage: number | null
  hasValidResult: boolean
}

type Emits = {
  detailButtonClicked: [value: boolean]
}

const props = withDefaults(defineProps<Props>(), { isLoading: false, hasValidResult: false })
const emit = defineEmits<Emits>()

function onContactButtonClick() {
  window.open('https://leasing.linexo.de/service/kontakt', '_blank')
}

function onDetailButtonClick() {
  emit('detailButtonClicked', true)
}
</script>

<style lang="scss" scoped>
@import 'o-result';
</style>
